import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PaymentCard({ payment }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id_payment, load_id, amount_value, currency, payment_date, created_at, pay_status } = payment;

  const isPaid = pay_status === 'paid';

  // created_at comes back from MySQL as "2026-07-14 10:32:00" — trim to just the date part
  const createdDateOnly = created_at ? created_at.split(' ')[0] : '—';

  return (
    <div onClick={() => navigate(`/payments/${id_payment}`)} style={styles.card}>
      <div style={styles.left}>
        <div style={styles.loadLabel}>{t('payments.load')} #{load_id}</div>
        <div style={styles.dateLine}>
          {t('paymentDetail.createdDate')}: {createdDateOnly}
        </div>
        {isPaid && payment_date && (
          <div style={styles.dateLinePaid}>
            {t('paymentDetail.paymentDate')}: {payment_date}
          </div>
        )}
      </div>
      <div style={styles.right}>
        <div style={styles.amount}>
          {Number(amount_value).toLocaleString()} {currency}
        </div>
        <span style={{
          ...styles.statusPill,
          backgroundColor: isPaid ? '#d1fae5' : '#fef3c7',
          color: isPaid ? '#065f46' : '#92400e',
        }}>
          {isPaid ? t('payments.paid') : t('payments.notPaid')}
        </span>
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 14,
    marginBottom: 12,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    cursor: 'pointer',
  },
  left: {},
  loadLabel: {
    fontWeight: 700,
    fontSize: 14,
    color: '#111827',
    marginBottom: 4,
  },
  dateLine: {
    fontSize: 12,
    color: '#9ca3af',
  },
  dateLinePaid: {
    fontSize: 12,
    color: '#065f46',
    marginTop: 2,
    fontWeight: 600,
  },
  right: {
    textAlign: 'right',
  },
  amount: {
    fontWeight: 700,
    fontSize: 15,
    color: '#111827',
    marginBottom: 4,
  },
  statusPill: {
    fontSize: 11,
    fontWeight: 700,
    padding: '3px 10px',
    borderRadius: 999,
    whiteSpace: 'nowrap',
  },
};

export default PaymentCard;